import * as React from "react";
const SvgBack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 20, viewBox: "0 0 13 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 2L2 10L11 18", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgBack;
